import { useEffect, Component } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Profile from "@/components/sections/Profile";
import EpoxyBox from "@/components/sections/EpoxyBox";
import Process from "@/components/sections/Process";
import Machinery from "@/components/sections/Machinery";
import Tooling from "@/components/sections/Tooling";
import Quality from "@/components/sections/Quality";
import Engineering from "@/components/sections/Engineering";
import Production from "@/components/sections/Production";
import Products from "@/components/sections/Products";
import Industries from "@/components/sections/Industries";
import WhyUs from "@/components/sections/WhyUs";
import Enquiry from "@/components/sections/Enquiry";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { initSmooth } from "@/lib/smooth";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { err: false };
    }
    static getDerivedStateFromError() {
        return { err: true };
    }
    componentDidCatch(e) {
        console.error(e);
    }
    render() {
        if (this.state.err) {
            return (
                <div className="min-h-screen bg-[#09090b] flex items-center justify-center font-mono text-sm text-zinc-400">
                    Something went wrong — please refresh the page.
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    useEffect(() => {
        initSmooth();
    }, []);

    return (
        <ErrorBoundary>
            <div className="relative bg-[#09090b] text-zinc-100 min-h-screen">
                <div className="noise-overlay" />
                <Navbar />
                <main>
                    <Hero />
                    <Marquee />
                    <Profile />
                    <EpoxyBox />
                    <Process />
                    <Machinery />
                    <Tooling />
                    <Quality />
                    <Engineering />
                    <Production />
                    <Products />
                    <Industries />
                    <WhyUs />
                    <Enquiry />
                </main>
                <Footer />
                <Toaster
                    position="bottom-right"
                    theme="dark"
                    toastOptions={{
                        style: {
                            background: "#18181b",
                            border: "1px solid #3f3f46",
                            color: "#fafafa",
                            borderRadius: "0",
                        },
                    }}
                />
                <WhatsAppButton />
            </div>
        </ErrorBoundary>
    );
}

export default App;